import { render, staticRenderFns } from "./PaymentsAndInvoicesSelector.vue?vue&type=template&id=f7fa0d2c&scoped=true&"
import script from "./PaymentsAndInvoicesSelector.vue?vue&type=script&lang=js&"
export * from "./PaymentsAndInvoicesSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fa0d2c",
  null
  
)

export default component.exports